import comp from "./VerifyOTP";
export default comp;
